// src/components/modals/ApiKeyModal.jsx
// Disederhanakan: tidak lagi menangani input API Key
// Hanya menampilkan info bahwa API dikelola server

import React from 'react';
import { X, ShieldCheck, Zap, Server } from 'lucide-react';

export default function ApiKeyModal({
  isOpen,
  onClose,
  // Props lama dipertahankan agar tidak error di App.jsx
  initialProvider,
  geminiApiKey,
  cohereApiKey,
  onSave,
  onDemo,
}) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex justify-center items-end sm:items-center p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div
        className="
          w-full max-w-md
          bg-white dark:bg-slate-800
          rounded-t-[32px] sm:rounded-[32px]
          shadow-soft-xl
          border border-stone-100 dark:border-slate-700
          overflow-hidden
          animate-slide-up
        "
      >
        {/* ── Drag Handle (mobile) ──────────────────── */}
        <div className="flex justify-center pt-3 pb-1 sm:hidden">
          <div className="w-10 h-1 bg-stone-300 dark:bg-slate-600 rounded-full" />
        </div>

        {/* ── Header ───────────────────────────────── */}
        <div className="flex items-center justify-between px-5 pt-4 pb-4 border-b border-stone-100 dark:border-slate-700">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-2xl bg-green-100 dark:bg-green-900/30 flex items-center justify-center">
              <Server className="w-5 h-5 text-green-600 dark:text-green-400" />
            </div>
            <div>
              <h3 className="text-sm font-extrabold text-slate-800 dark:text-slate-100">
                Konfigurasi AI
              </h3>
              <p className="text-[11px] text-slate-400 dark:text-slate-500">
                Dikelola aman di server Cloudflare
              </p>
            </div>
          </div>

          <button
            onClick={onClose}
            className="
              w-8 h-8 rounded-full
              bg-stone-100 dark:bg-slate-700
              hover:bg-stone-200 dark:hover:bg-slate-600
              flex items-center justify-center
              transition-all active:scale-90
            "
          >
            <X className="w-4 h-4 text-slate-500" />
          </button>
        </div>

        {/* ── Konten ───────────────────────────────── */}
        <div className="p-5 space-y-4">

          {/* Info Utama */}
          <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800/40 rounded-3xl p-4 flex items-start gap-3">
            <ShieldCheck className="w-6 h-6 text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-extrabold text-green-800 dark:text-green-300 mb-1">
                API Key Tersimpan di Server
              </p>
              <p className="text-xs text-green-700 dark:text-green-400 leading-relaxed">
                Anda tidak perlu memasukkan API Key. Semua request diproses secara aman melalui Cloudflare Edge Network dan tidak pernah terekspos ke browser.
              </p>
            </div>
          </div>

          {/* Status Provider */}
          <div className="space-y-2">
            <p className="text-[10px] font-extrabold text-stone-500 dark:text-slate-400 uppercase tracking-widest">
              Status Provider
            </p>

            {/* Gemini Status */}
            <div className="flex items-center justify-between bg-sky-50 dark:bg-sky-900/20 border border-sky-100 dark:border-sky-800/40 rounded-2xl px-4 py-3">
              <div className="flex items-center gap-2.5">
                <Zap className="w-4 h-4 text-sky-500" />
                <div>
                  <p className="text-xs font-bold text-sky-800 dark:text-sky-300">
                    Google Gemini
                  </p>
                  <p className="text-[10px] text-sky-600 dark:text-sky-400 font-mono">
                    gemini-2.5-flash
                  </p>
                </div>
              </div>
              <span className="text-[10px] font-extrabold bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-400 px-2.5 py-1 rounded-full">
                ✓ Aktif
              </span>
            </div>

            {/* Cohere Status */}
            <div className="flex items-center justify-between bg-purple-50 dark:bg-purple-900/20 border border-purple-100 dark:border-purple-800/40 rounded-2xl px-4 py-3">
              <div className="flex items-center gap-2.5">
                <Zap className="w-4 h-4 text-purple-500" />
                <div>
                  <p className="text-xs font-bold text-purple-800 dark:text-purple-300">
                    Sabenih AI
                  </p>
                  <p className="text-[10px] text-purple-600 dark:text-purple-400 font-mono">
                    command-r-08-2024
                  </p>
                </div>
              </div>
              <span className="text-[10px] font-extrabold bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-400 px-2.5 py-1 rounded-full">
                ✓ Aktif
              </span>
            </div>
          </div>

          {/* Tombol Tutup */}
          <button
            onClick={onClose}
            className="
              w-full
              bg-gradient-to-r from-green-500 to-green-600
              hover:from-green-600 hover:to-green-700
              text-white font-extrabold text-sm
              py-3.5 rounded-3xl
              shadow-soft transition-all active:scale-95
            "
          >
            Mengerti
          </button>

        </div>
      </div>
    </div>
  );
}